import dayjs, { Dayjs } from "dayjs"

export const getValidDayjs = (value: any): Dayjs => {
  let dayjsValue: any = value

  if (!dayjs.isDayjs(dayjsValue)) {
    dayjsValue = dayjs(dayjsValue)
    if (!dayjsValue.isValid()) {
      dayjsValue = dayjs()
    }
  }

  return dayjsValue
}